import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-donut-with-centered-text',
  templateUrl: './donut-with-centered-text.component.html',
  styleUrls: ['./donut-with-centered-text.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonutWithCenteredTextComponent implements OnInit {
  public isEmpty: boolean;
  public refresRate: any = 0;
  private _showPageLevelFilterWarning: boolean = true;
  @Output() public onTitleClicked = new EventEmitter();
  @Input() public titleClickable: boolean;
  @Input() public set showPageLevelFilterWarning(val) { this._showPageLevelFilterWarning = val; }
  public get showPageLevelFilterWarning( ) { return  this._showPageLevelFilterWarning; }
  
  @Input() public innerTopTitle: string
  @Input() public innerHeader: string
  @Input() public innerTitle: string
  @Input() public innerText: string
  @Input() public categoryField: string = 'cat'
  @Input() public categoryValue: string = 'count'
  @Input() public categoryColors: any = [];
  private _data: any[] = [];
  @Input() public set data(value) {
    if (!value) {
      this.isEmpty = true;
      var prop = {};
      prop[this.categoryField] = 'No Data';
      prop[this.categoryValue] = 1;
      value = [prop]
    }
    else this.isEmpty = false;
    this._data = value;
    this.refresRate = 1;
    setTimeout(() => {
      this.refresRate = 0;
    }, 1)
   
  }; public get data() {
    return this._data;
  };


  public barColor = (point): string => {
    if (this.isEmpty)
      return "#f5f5f5"
    if (this.categoryColors) {
      var filt = this.categoryColors.filter(o => {
        return o.cat == point.category
      })
      if (filt.length == 0)
        return;
      else return filt[0].color;
    }
    return;

  }

  public labelContent(e: any): string {
    return Math.round(e.percentage * 100).toString() + '%';
  }
  constructor() { }
  ngOnInit(): void {
    
  }
  public titleClicked() {
    if (this.titleClickable)
      this.onTitleClicked.emit();
  }



}
